export default __webpack_public_path__ + "static/media/rating_6_reject.0ee3be7b.png";